interface IData {
  taskId?: string;
  processInstanceId?: string;
}
export const getProcessDataFromUrl = () => {
  const search = window.location.search;
  const searchParams = new URLSearchParams(search);
  const processInstanceId = searchParams.get("processInstanceId");
  const taskId = searchParams.get("taskId");
  const data: IData = {};
  if (taskId) {
    data.taskId = taskId;
  }
  if (processInstanceId) {
    data.processInstanceId = processInstanceId;
  }
  return data;
};
